// extracted by mini-css-extract-plugin
export default {"root":"PhotoItem_root__YWXOI","photo":"PhotoItem_photo__4DSCb","footer":"PhotoItem_footer__d0CZS"};